import React, { ReactNode } from "react";
import BoxTitleWrapper from "./BoxTitle";
import { BoxWrapper, getBoxContentClasses, boxFooterClasses } from "./box.style";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import classNames from "classnames";
import { useToggle, useUpdateEffect } from "react-use";
import BoxTitleExpandable from "./BoxTitleExpandable";

export default (props: {
  title?: ReactNode;
  footer?: ReactNode;
  subtitle?: string;
  children?: React.ReactNode;
  fullWidth?: boolean;
  icon?: IconProp;
  roundBottom?: boolean;
  roundTop?: boolean;
  className?: string;
  middle?: boolean;
  plain?: boolean;
  noShadow?: boolean;
  contentCenter?: boolean;
  customTitle?: ReactNode;
  titleExtra?: ReactNode;
  fullHeight?: boolean;
  underline?: boolean;
  topPadding?: boolean;
  tableMode?: boolean;
  hidden?: boolean;
  expandable?: boolean;
  open?: boolean;
  dataCy?: string;
  bordered?: boolean;
}) => {
  const [open, toggleOpen] = useToggle(!props.expandable);

  useUpdateEffect(() => {
    toggleOpen(props.open);
  }, [props.open]);

  if (props.hidden) {
    return null;
  }

  const boxContentClasses = getBoxContentClasses({
    tableMode: props.tableMode,
    fullWidth: props.fullWidth,
    contentCenter: props.contentCenter,
    topPadding: props.topPadding,
  });

  return (
    <BoxWrapper
      bordered={props.bordered}
      className={classNames("isoBoxWrapper", { "underline-title": props.underline }, props.className)}
      contentCenter={props.contentCenter}
      expandable={props.expandable}
      fullHeight={props.fullHeight}
      fullWidth={props.fullWidth}
      middle={props.middle}
      plain={props.plain}
      roundBottom={props.roundBottom}
      roundTop={props.roundTop}
      tableMode={props.tableMode}
      topPadding={props.topPadding}
    >
      {props.title && !props.expandable && (
        <BoxTitleWrapper
          extra={props.titleExtra}
          icon={props.icon}
          inner={props.roundBottom}
          middle={props.middle}
          plain={props.plain}
          subtitle={props.subtitle}
          title={props.title}
          underline={props.underline}
        />
      )}
      {props.title && props.expandable && (
        <BoxTitleExpandable
          expandable={props.expandable}
          extra={props.titleExtra}
          icon={props.icon}
          inner={props.roundBottom}
          middle={props.middle}
          open={open}
          plain={props.plain}
          subtitle={props.subtitle}
          title={props.title}
          toggleOpen={toggleOpen}
          underline={props.underline}
        />
      )}
      {open && props.customTitle && props.customTitle}
      {open && (
        <div className={classNames("box-content", boxContentClasses)} data-cy={props.dataCy}>
          {props.children}
        </div>
      )}
      {props.footer && <div className={classNames("box-footer", boxFooterClasses)}>{props.footer}</div>}
    </BoxWrapper>
  );
};
